import { useEffect, useState } from 'react'
import { Input, SelectInput, Spinner } from 'asocomponents'
import PagosSinFacturaService from '../../../../modules/Liquidacion/application/PagosSinFacturaService'
import { validarCBU, validarCuit } from '../../../helpers/funciones.js'

export default function FormasPago({ onCambioFormaPago }) {

    const usuarioString = sessionStorage.getItem("usuario") && JSON.parse(sessionStorage.getItem("usuario"))
    const cuitLetrado = usuarioString.usuario

    const [formasDePago, setFormasDePago] = useState([])
    const [logicaCampos, setLogicaCampos] = useState({})
    const [isLoading, setIsLoading] = useState(true)

    const [forma, setForma] = useState('')
    const [subforma, setSubforma] = useState('')
    const [valor1, setValor1] = useState('')
    const [valor2, setValor2] = useState('')
    const [errores, setErrores] = useState({})

    const cargarInfoFormaPago = async () => {
        setIsLoading(true)

        let formas = []
        const servicePago = new PagosSinFacturaService()
        const formasPago = await servicePago.getFormasPago()
        const logica = await servicePago.getDetalleFormaPago()

        //Valido si existe el cuit del letrado en los casos de subformas de reintegros, si no existe elimino la forma reintegro
        const existeCuit = formasPago.some(obj =>
            obj.subformas.some(sub => sub.label.includes(cuitLetrado))
        )

        if (existeCuit) {
            formas = formasPago.map(item => {
                if (item.label.toUpperCase() === "REINTEGRO ESTUDIO") {
                    return {
                        ...item,
                        subformas: item.subformas.filter(sub => sub.label.includes(cuitLetrado))
                    }
                }
                return item;
            })
        }
        else {
            formas = formasPago.filter(forma => forma.label !== "REINTEGRO ESTUDIO")
        }

        setFormasDePago(formas)
        setLogicaCampos(logica)
        setIsLoading(false)
    }

    useEffect(() => {
        cargarInfoFormaPago()
    }, [])

    const campos = (() => {
        if (!forma) return null
        const logica = logicaCampos[forma]
        if (!logica) return null
        if (logica[subforma]) return logica[subforma]
        return logica
    })()

    // Función de validación que solo retorna los errores (no actualiza estado)
    const validar = () => {
        const nuevosErrores = {}

        const ejecutarValidacion = (codigo, valor) => {
            try {
                const fn = new Function('valor', 'validarCBU', 'validarCuit', `return ${codigo}`)
                return fn(valor, validarCBU, validarCuit)
            } catch (err) {
                console.error('Error en validación:', err)
                return false
            }
        }

        if (campos?.descripcionPago1?.visible && campos.descripcionPago1?.validacion) {
            const isValid = ejecutarValidacion(campos.descripcionPago1.validacion, valor1)
            if (!isValid) nuevosErrores.valor1 = '(*)'
        }

        if (campos?.descripcionPago2?.visible && campos.descripcionPago2?.validacion) {
            const isValid = ejecutarValidacion(campos.descripcionPago2.validacion, valor2)
            if (!isValid) nuevosErrores.valor2 = '(*)'
        }

        return nuevosErrores
    }

    // Cada vez que cambian los valores o campos, validamos y seteamos errores
    useEffect(() => {
        const nuevosErrores = validar()
        setErrores(nuevosErrores)
    }, [valor1, valor2, campos])

    // Cuando cambian forma, subforma, valores o errores, solo llamamos si no hay errores
    useEffect(() => {
        if (onCambioFormaPago) {
            const formaSeleccionada = formasDePago.find(f => f.id === forma)
            const subformaSeleccionada = formaSeleccionada?.subformas?.find(sf => sf.id === subforma)
            onCambioFormaPago({
                forma: formaSeleccionada,
                subforma: subformaSeleccionada || null,
                descripcionPago1: valor1,
                descripcionPago2: valor2,
                errores
            })
        }
    }, [forma, subforma, valor1, valor2, errores])

    useEffect(() => {
        if (campos?.descripcionPago1?.valorFijo !== undefined && campos?.descripcionPago1?.valorFijo !== null) {
            setValor1(campos?.descripcionPago1?.valorFijo)
        }
        if (campos?.descripcionPago2?.valorFijo !== undefined && campos?.descripcionPago2?.valorFijo !== null) {
            setValor2(campos?.descripcionPago2?.valorFijo)
        }
    }, [campos])

    if (isLoading) {
        return <Spinner color="red" size="15" />
    }

    return (
        <div className='flex flex-col justify-left items-left'>
            <div className='flex flex-row justify-left items-left mb-2'>

                <SelectInput
                    options={formasDePago}
                    placeholder="Seleccionar"
                    todos={false}
                    labelField="label"
                    onChange={e => {
                        setForma(e.target.value)
                        setSubforma('')
                        setValor1('')
                        setValor2('')
                        setErrores({})
                    }}
                    defaultValue={forma || "-2"}
                    width="w-52"
                />

                {forma && formasDePago.find(f => f.id === forma)?.subformas.length > 0 && (
                    <SelectInput
                        value={subforma}
                        onChange={e => {
                            setSubforma(e.target.value)
                            setValor1('')
                            setValor2('')
                            setErrores({})
                        }}
                        options={formasDePago.find(f => f.id === forma).subformas}
                        width="w-48"
                        todos={false}
                        placeholder="Seleccionar"
                        labelField="label"
                    />
                )}

                {(campos?.descripcionPago1?.visible || campos?.descripcionPago2?.visible) && (
                    <div className='flex flex-row justify-left items-left'>
                        {campos?.descripcionPago1?.visible && (
                            <div className='flex flex-row justify-left items-left mr-4'>
                                <Input
                                    type={campos.descripcionPago1.tipoCampo}
                                    disabled={campos.descripcionPago1.habilitado === "false" ? "true" : "false"}
                                    valor={campos.descripcionPago1.valorFijo ?? valor1}
                                    onChange={e => setValor1(e)}
                                    placeholder={campos.descripcionPago1.placeholder}
                                    maxlength={String(campos.descripcionPago1.intLongitud)}
                                    width="w-40"
                                />
                                {errores.valor1 && <p className="text-red-600">{errores.valor1}</p>}
                            </div>
                        )}

                        {campos?.descripcionPago2?.visible && (
                            <div className='flex flex-row justify-left items-left'>
                                <Input
                                    type={campos.descripcionPago2.tipoCampo}
                                    disabled={campos.descripcionPago2.habilitado === "false" ? "true" : "false"}
                                    valor={campos.descripcionPago2.valorFijo ?? valor2}
                                    onChange={e => setValor2(e)}
                                    placeholder={campos.descripcionPago2.placeholder}
                                    maxlength={campos.descripcionPago2.intLongitud}
                                    width="w-40"
                                />
                                {errores.valor2 && <p className="text-red-600">{errores.valor2}</p>}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
